import React from "react";

import Text from "src/components/text";
import { formatTimespent } from "src/services/reports.service";

import styles from "./styles.module.scss";
import { UserGroup } from "src/types/users";
import { Analytics } from "src/types/reports";

export interface TopSharedUserGroupCardProps {
  item: {
    userGroup: UserGroup;
    analytics: Analytics;
  };
}

export const TopSharedUserGroupCard: React.FC<TopSharedUserGroupCardProps> = ({ item }) => {
  const { userGroup, analytics } = item;
  return (
    <a
      href={`/settings/user-management/group/${userGroup.id}`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.linkWrapper}
    >
      <div className={styles.card}>
        <div className={styles.content}>
          <div className={styles.imageIcon}>
            {userGroup?.icon?.thumbnail ? (
              <img src={userGroup.icon.thumbnail} alt="User Icon" />
            ) : (
              <span className={styles.initials}>
                {userGroup.name?.charAt(0).toUpperCase() || "U"}
              </span>
            )}
          </div>
        </div>
        <div className={styles.info}>
          <Text
            lines={1}
            className={styles.title}
            text={userGroup.name || ""}
          />
          <div className={styles.metrics}>
            <span>{analytics.shares || 0} Shares</span>
            <span>{analytics.assets || 0} Assets</span>
          </div>
        </div>
      </div>
    </a>
  );
};
